export const mocksAssessmentProps = {
	step1completed: "",
	step2completed: "",
	tree: '',
	businessName: "",
	finalscore: "",
	recommendation: "",
	ErrorType:"",
	qnum:"",
	item:{
		"id": "21",
		"externalId": "45",
		"questionText": "Do you know what information you need to include when building a website?",
		"responseType": "multipleChoiceSingleResponse",
		"responseOption": [
			"Yes",
			"No"
		],
		"relatedQuestion": [
			{
				"externalId": "115",
				"relationship": {
					"relationship": "followUp",
					"criteriaName": "response",
					"criteriaValue": [
						"Yes"
					],
					"criteriaOperator": "EQ"
				},
				"question": {
					"id": "41",
					"questionText": "Do you intend to build your own website?",
					"responseType": "multipleChoiceSingleResponse",
					"responseOption": [
						"Yes",
						"No"
					]
				}
			},
			{
				"externalId": "116",
				"relationship": {
					"relationship": "followUp",
					"criteriaName": "response",
					"criteriaValue": [
						"Yes"
					],
					"criteriaOperator": "EQ"
				},
				"question": {
					"id": "42",
					"questionText": "Have you purchased a domain name for your business website from a domain name provider (e.g., GoDaddy)?",
					"responseType": "multipleChoiceSingleResponse",
					"responseOption": [
						"Yes",
						"No"
					]
				}
			},
			{
				"externalId": "117",
				"relationship": {
					"relationship": "followUp",
					"criteriaName": "response",
					"criteriaValue": [
						"Yes"
					],
					"criteriaOperator": "EQ"
				},
				"question": {
					"id": "43",
					"questionText": "Do you know who owns the SSL certificate for your website?",
					"responseType": "multipleChoiceSingleResponse",
					"responseOption": [
						"Yes",
						"No"
					]
				}
			},
			{
				"externalId": "118",
				"relationship": {
					"relationship": "followUp",
					"criteriaName": "response",
					"criteriaValue": [
						"Yes"
					],
					"criteriaOperator": "EQ"
				},
				"question": {
					"id": "44",
					"questionText": "Are you using a hosting service for your website?",
					"responseType": "multipleChoiceSingleResponse",
					"responseOption": [
						"Yes",
						"No"
					]
				}
			},
			{
				"externalId": "119",
				"relationship": {
					"relationship": "followUp",
					"criteriaName": "response",
					"criteriaValue": [
						"Yes"
					],
					"criteriaOperator": "EQ"
				},
				"question": {
					"id": "45",
					"questionText": "Is your domain name successfully connected to your business website?",
					"responseType": "multipleChoiceSingleResponse",
					"responseOption": [
						"Yes",
						"No"
					]
				}
			}
		]
	},
	twinpairquestionsarray:{
		"id": "9",
		"item": {
			"question": [
				{
					"id": "21",
					"externalId": "45",
					"questionText": "Do you know what information you need to include when building a website?",
					"responseType": "multipleChoiceSingleResponse",
					"responseOption": [
						"Yes",
						"No"
					],
					"relatedQuestion": [
						{
							"externalId": "115",
							"relationship": {
								"relationship": "followUp",
								"criteriaName": "response",
								"criteriaValue": [
									"Yes"
								],
								"criteriaOperator": "EQ"
							},
							"question": {
								"id": "41",
								"questionText": "Do you intend to build your own website? ",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Yes",
									"No"
								]
							}
						},
						{
							"externalId": "116",
							"relationship": {
								"relationship": "followUp",
								"criteriaName": "response",
								"criteriaValue": [
									"Yes"
								],
								"criteriaOperator": "EQ"
							},
							"question": {
								"id": "42",
								"questionText": "Have you purchased a domain name for your business website from a domain name provider (e.g., GoDaddy)?",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Yes",
									"No"
								]
							}
						},
						{
							"externalId": "117",
							"relationship": {
								"relationship": "followUp",
								"criteriaName": "response",
								"criteriaValue": [
									"Yes"
								],
								"criteriaOperator": "EQ"
							},
							"question": {
								"id": "43",
								"questionText": "Do you know who owns the SSL certificate for your website?",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Yes",
									"No"
								]
							}
						},
						{
							"externalId": "118",
							"relationship": {
								"relationship": "followUp",
								"criteriaName": "response",
								"criteriaValue": [
									"Yes"
								],
								"criteriaOperator": "EQ"
							},
							"question": {
								"id": "44",
								"questionText": "Are you using a hosting service for your website? ",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Yes",
									"No"
								]
							}
						},
						{
							"externalId": "119",
							"relationship": {
								"relationship": "followUp",
								"criteriaName": "response",
								"criteriaValue": [
									"Yes"
								],
								"criteriaOperator": "EQ"
							},
							"question": {
								"id": "45",
								"questionText": "Is your domain name successfully connected to your business website?",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Yes",
									"No"
								]
							}
						}
					]
				},
				{
					"id": "22",
					"externalId": "46",
					"questionText": "Would you like to know how to build a more responsive website?",
					"responseType": "multipleChoiceSingleResponse",
					"responseOption": [
						"Yes",
						"No"
					],
					"relatedQuestion": [
						{
							"externalId": "120",
							"relationship": {
								"relationship": "followUp",
								"criteriaName": "response",
								"criteriaValue": [
									"Yes"
								],
								"criteriaOperator": "EQ"
							},
							"question": {
								"id": "46",
								"questionText": "Is your business website mobile-friendly? ",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Yes",
									"No"
								]
							}
						},
						{
							"externalId": "121",
							"relationship": {
								"relationship": "followUp",
								"criteriaName": "response",
								"criteriaValue": [
									"Yes"
								],
								"criteriaOperator": "EQ"
							},
							"question": {
								"id": "47",
								"questionText": "Have you checked that your website is compatible with the most frequently used browsers? ",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Yes",
									"No"
								]
							}
						}
					]
				},
				{
					"id": "23",
					"externalId": "47",
					"questionText": "Would you like to know how to build a Search Engine Optimised (SEO) website?",
					"responseType": "multipleChoiceSingleResponse",
					"responseOption": [
						"Yes",
						"No"
					],
					"relatedQuestion": [
						{
							"externalId": "122",
							"relationship": {
								"relationship": "followUp",
								"criteriaName": "response",
								"criteriaValue": [
									"Yes"
								],
								"criteriaOperator": "EQ"
							},
							"question": {
								"id": "48",
								"questionText": "Do you create and publish content with relevant keywords to ensure your business appears in top search results?",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Yes",
									"No"
								]
							}
						},
						{
							"externalId": "123",
							"relationship": {
								"relationship": "followUp",
								"criteriaName": "response",
								"criteriaValue": [
									"Yes"
								],
								"criteriaOperator": "EQ"
							},
							"question": {
								"id": "50",
								"questionText": "Have you included a site map on your website? ",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Yes",
									"No"
								]
							}
						},
						{
							"externalId": "124",
							"relationship": {
								"relationship": "followUp",
								"criteriaName": "response",
								"criteriaValue": [
									"Yes"
								],
								"criteriaOperator": "EQ"
							},
							"question": {
								"id": "53",
								"questionText": "Do you know how to use website analytics tools to improve your website Search Engine Optimisation (SEO)?",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Yes",
									"No"
								]
							}
						},
						{
							"externalId": "106",
							"relationship": {
								"relationship": "followUp",
								"criteriaName": "response",
								"criteriaValue": [
									"Yes"
								],
								"criteriaOperator": "EQ"
							},
							"question": {
								"id": "81",
								"questionText": "Do you regularly update the content on your website? ",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Yes",
									"No"
								]
							}
						}
					]
				}
			]
		}
	},
	questionnumbertext:{
		"goals":[
			"hello",
			"Welcome",
			"Goodbye"
		]
	},
	loader3:true,
	 updateGoalsResponse : (mainQID: any, mainextID: any, mainResp: any, realtedQuestions: any = "") => {
	
	},
	goalsSecPropFunction:(anum: any, enable: any)=>{

	},
	getAssessmentAPI:(surveyid: any, gettype: any, twinxid: any)=>{

	},
	setGoalsSection:(True: any)=>{

	},
	businessQuestions2to7:{
		"result": {
			"id": "8136",
			"direction": "outbound",
			"reason": "Customer wants to take a assessment",
			"interactionItem": [
				{
					"item": {
						"question": [
							{
								"id": "1",
								"questionText": "What type of business do you operate?",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Accommodation & Food",
									"Arts & Entertainment",
									"Construction",
									"Education",
									"Financial & Insurance",
									"Goods Manufacturing",
									"Human Health & Social Work",
									"Information & Communication",
									"Professional, Scientific & Technical Service",
									"Travel & Transportation",
									"Wholesale & Retail Trade"
								]
							},
							{
								"id": "2",
								"questionText": "When did you launch your business (in years)?",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"1-2",
									"3-5",
									"6-10",
									">10"
								]
							},
							{
								"id": "3",
								"questionText": "What is your annual revenue range (in GBP)?",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Below 300K",
									"Between 300K - 1Mn",
									"Above 1Mn"
								]
							},
							{
								"id": "4",
								"questionText": "How many employees work in your company?",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Below 10",
									"10 to 50",
									"Above 50"
								]
							},
							{
								"id": "5",
								"questionText": "Who are your main customers?",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Consumers",
									"B2B",
									"Both"
								]
							},
							{
								"id": "6",
								"questionText": "How many locations does your business operate in across the UK?",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"1-2",
									"3-5",
									"6-10",
									">10"
								]
							}
						]
					}
				}
			]
		}
	},
	patchBusinessAnswersAPI:{
			"status": 200,
			"result": {
				"id": "8086",
				"interactionItem": [
					{
						"id": "2"
					}
				]
			}
	},
	SurveyPageGetResponce:{
		"status": 200,
		"result": {
			"id": "8115",
			"direction": "outbound",
			"reason": "Customer wants to take a assessment",
			"interactionItem": [
				{
					"id": "23",
					"item": {
						"question": [
							{
								"id": "35",
								"externalId": "23",
								"questionText": "Do you have a defined policy on how to deal with ransomware attacks?",
								"responseType": "multipleChoiceSingleResponse",
								"responseOption": [
									"Yes",
									"No"
								],
								"relatedQuestion": [
									{
										"externalId": "211",
										"relationship": {
											"relationship": "followUp",
											"criteriaName": "response",
											"criteriaValue": [
												"Yes"
											],
											"criteriaOperator": "EQ"
										},
										"question": {
											"id": "119",
											"questionText": "Are you restricting usage of unauthorized software/ programs on company-registered devices?",
											"responseType": "multipleChoiceSingleResponse",
											"responseOption": [
												"Yes",
												"No"
											]
										}
									},
									{
										"externalId": "212",
										"relationship": {
											"relationship": "followUp",
											"criteriaName": "response",
											"criteriaValue": [
												"Yes"
											],
											"criteriaOperator": "EQ"
										},
										"question": {
											"id": "120",
											"questionText": "Are you conducting regular digital security awareness training to educate your employees about ransomware attacks?",
											"responseType": "multipleChoiceSingleResponse",
											"responseOption": [
												"Yes",
												"No"
											]
										}
									},
									{
										"externalId": "213",
										"relationship": {
											"relationship": "followUp",
											"criteriaName": "response",
											"criteriaValue": [
												"Yes"
											],
											"criteriaOperator": "EQ"
										},
										"question": {
											"id": "121",
											"questionText": "Do you educate your employees on how to spot and report potential phishing emails containing malicious attachments?",
											"responseType": "multipleChoiceSingleResponse",
											"responseOption": [
												"Yes",
												"No"
											]
										}
									},
									{
										"externalId": "214",
										"relationship": {
											"relationship": "followUp",
											"criteriaName": "response",
											"criteriaValue": [
												"Yes"
											],
											"criteriaOperator": "EQ"
										},
										"question": {
											"id": "122",
											"questionText": "Do you educate your employees on how to detect potentially malicious or compromised websites?",
											"responseType": "multipleChoiceSingleResponse",
											"responseOption": [
												"Yes",
												"No"
											]
										}
									}
								]
							}
						]
					}
				}
			]
		}
	},
	patchGoalsAnswersAPI:{
		"status": 200,
		"result": {
			"id": "8207",
			"status": "SUCCESS",
			"interactionItem": [
				{
					"id": "39"
				}
			]
		}
	},
	 MockSummaryDownloadBanner1:{
		"status": 200,
		"result": {
			"status": "Success",
			"attachment": [
				{
					"content": "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"
				}
			]
		}
	},
	 MockSectionTcsSummaryPageGet : {
		
			result: {
				interactionItem: [{
					item: {
						recommendationItem: [{ title: 'Title1', text: 'text', relatedRecommendationItem: [{ recommendationItem: { title: 'recom title', text: 'recom text' } }] }], characteristic: [{
							value: {
								categories: [{
									type: 'available',
									nodeName: 'test'
								}],
								sub_categories: [{
									type: 'available',
									nodeName: 'test'
								}, {
									type: 'available',
									nodeName: 'test'
								}, {
									type: '',
									nodeName: 'test12'
								}, {
									type: 'available',
									nodeName: 'test23'
								}, {
									type: '',
									nodeName: 'test45'
								}],
								entities: [
									{
										maturitypercent: 35,
										nodeName: 'example',
										attributes: [{
											type: 'missing',
											nodeName: 'Test nodename'
										}, {
											type: 'available',
											nodeName: 'Test available'
										}],
										children: {}
									}
								]
							}
						}]
					}
				}]
			}
		
	},
	GetCategorieQuestion:{
		"status": 200,
		"result": [
			{
				"category_id": 1,
				"catergory_name": "Habilidades digitales",
				"subcategories": [
				  {
					"sc_id": 1,
					"sub_category_name": "Construyendo presencia digital"
				  },
				  {
					"sc_id": 2,
					"sub_category_name": "Optimización del motor de búsqueda"
				  },
				  {
					"sc_id": 3,
					"sub_category_name": "Crear un sitio web"
				  },
				  {
					"sc_id": 4,
					"sub_category_name": "Publicidad en Redes Sociales"
				  },
				  {
					"sc_id": 5,
					"sub_category_name": "Seguimiento de los visitantes en tu sitio web"
				  }
				]
			  },
			  {
				"category_id": 2,
				"catergory_name": "Seguridad digital",
				"subcategories": [
				  {
					"sc_id": 6,
					"sub_category_name": "Amenazas comunes de seguridad"
				  },
				  {
					"sc_id": 7,
					"sub_category_name": "Seguridad para múltiples dispositivos"
				  },
				  {
					"sc_id": 8,
					"sub_category_name": "Protección de ransomware"
				  },
				  {
					"sc_id": 9,
					"sub_category_name": "Seguridad en el teletrabajo"
				  }
				]
			  },
			  {
				"category_id": 3,
				"catergory_name": "Trabajo a distancia",
				"subcategories": [
				  {
					"sc_id": 10,
					"sub_category_name": "Productividad del equipo"
				  },
				  {
					"sc_id": 11,
					"sub_category_name": "Acceso remoto a los archivos"
				  },
				  {
					"sc_id": 12,
					"sub_category_name": "Red privada virtual"
				  },
				  {
					"sc_id": 13,
					"sub_category_name": "Herramientas de comunicación en línea"
				  }
				]
			  }
		]
	  }
};

export const mocksUrls = {
	BusQueTestUrl1:"https://locahost:3000/assessments/test1",
	BusQueTestUrl2:"https://locahost:3000/assessments/test2",
	SurveyPageGet:"https://locahost:3000/assessments/surveytest1",
	SurveyPagePatch:"https://locahost:3000/assessments/surveytest2",
	SumDowBannerUrl:"https://locahost:3000/assessments/summaryDownloadBanner",
	SecTcsSumPage:"http://localhost:3000/assessments/sectionTcsSummaryPage",
};